import DashboardSummaryCountsWidget from '../../../../components/DashboardSummaryCountsWidget/SummaryCountWidget'
import SvgIconPolicies from '../../../../assets/inlineSvg/icon-policies.svg'
import SvgIconMembers from '../../../../assets/inlineSvg/icon-members.svg'
import { RootState } from '../../../../rootReducer'
import { fetchCopilotSummaryData, ICopilotSummary } from '../../../summary/summarySlice'
import useUrlContext from '../../../../hooks/useUrlContext'
import { mockCopilotSummaryCountWidgetData } from '../../renderer/utils/widgetMockdata'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../../mainDashboardv2/constants'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import React, { useEffect } from 'react'

interface OwnProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDashboardId?: string
}

interface StateProps {
  widgetData: ICopilotSummary
  policiesCount?: number
}

interface DispatchProps {
  fetchCopilotSummaryData: (args: { datasourceId: string; [UNIQUE_WIDGET_INDEX]?: string }) => void
}

type CopilotSummaryCountsComponentProps = StateProps & DispatchProps & OwnProps

const CopilotSummaryCounts = ({
  fetchCopilotSummaryData,
  widgetData: { userCount },
  policiesCount,
  useMockData = false,
  widgetDatasourceId,
  widgetDashboardId
}: CopilotSummaryCountsComponentProps) => {
  const intl = useIntl()
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId ? widgetDatasourceId : context.contextFilters.datasourceId
  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)

  const widgetData1 = [
    {
      icon: <SvgIconMembers />,
      text: intl.formatMessage({ id: 'dashboard.copilot.widget.text.users' }),
      count: userCount || 0
    },
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.policies' }),
      count: policiesCount || 0
    }
  ]

  useEffect(() => {
    if (useMockData) return
    if (datasourceId) {
      fetchCopilotSummaryData({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
    }
  }, [datasourceId, fetchCopilotSummaryData, useMockData, widgetIndex])

  const isPoliciesCountAvailable = policiesCount !== undefined
  const isUsersCountAvailable = userCount !== undefined
  const countsAvailable = isUsersCountAvailable && isPoliciesCountAvailable
  const showLoader = !countsAvailable

  return (
    <DashboardSummaryCountsWidget
      summaryItems={widgetData1}
      showLoader={showLoader}
      useMockData={useMockData}
    />
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  const widgetIndex = getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
  return {
    widgetData: ownProps?.useMockData
      ? mockCopilotSummaryCountWidgetData.summaryCount
      : state.summary.widgetCopilotSummaryData?.[widgetIndex] || {},
    policiesCount: ownProps?.useMockData
      ? mockCopilotSummaryCountWidgetData.policiesCount
      : state.dashboardSummaryCounts.policiesCount?.[widgetIndex]
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchCopilotSummaryData
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(CopilotSummaryCounts)
